var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":require("../images/login/tongzhi.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.mer_broadcast))])]),_c('div',{staticClass:"right"},[_c('span',{on:{"click":function($event){return _vm.to('/applyProcess')}}},[_vm._v("报名流程")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }